import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/AppLayout';
// Read-only diagnostics page — gated at 'read' so Viewers can access it. Must stay
// aligned with the sidebar entry in components/layout/Sidebar.tsx (requiredPermission: 'read').
import { ViewerGuard } from '@/components/guards/ViewerGuard';
import { PageHeader } from '@/components/layout/PageHeader';
import { BridgeAnalysisTab } from '@/components/tools/BridgeAnalysisTab';

export const Route = createFileRoute('/tools/bridge-analysis')({
  component: BridgeAnalysisPage,
});

function BridgeAnalysisPage() {
  return (
    <AppLayout>
      <ViewerGuard>
        <PageHeader
          title="Bridge Analysis"
          description="Analyze a Bridge organization for migratability and duplication issues"
          breadcrumbs={[{ label: 'Tools' }, { label: 'Bridge Analysis' }]}
        />
        <BridgeAnalysisTab />
      </ViewerGuard>
    </AppLayout>
  );
}
